import { g as __rest, b as __assign } from '../../../../tslib.es6-14c74580.js';
import React__default from 'react';
import { c as classnames } from '../../../../index-f9fe84d4.js';
import '../../../../_commonjsHelpers-1a7a244d.js';

var List = function (_a) {
    var children = _a.children, forStatistics = _a.forStatistics, rest = __rest(_a, ["children", "forStatistics"]);
    var listClassNames = classnames('lists-wrapper', {
        statistics: forStatistics,
    });
    return (React__default.createElement("div", __assign({ className: listClassNames }, rest), children));
};

export { List };
